var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("breadcrumbs-bar", { attrs: { breadcrumbs: _vm.breadcrumbs } }),
      _c("div", { staticClass: "page-help" }, [
        _c("div", { staticClass: "page-help__title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.categoryTitle))])
        ]),
        _c("div", { staticClass: "page-help__body" }, [
          _c("div", { staticClass: "page-help__list" }, [
            _c(
              "ul",
              _vm._l(_vm.helpItems, function(item) {
                return _c(
                  "li",
                  [
                    _c("router-link", { attrs: { to: item.pageUrl } }, [
                      _c("span", {
                        domProps: { textContent: _vm._s(item.question) }
                      }),
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "11",
                            height: "18",
                            viewBox: "0 0 11 18",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M1 17L9 9L0.999999 1",
                              stroke: "#926D20",
                              "stroke-width": "2"
                            }
                          })
                        ]
                      )
                    ])
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]),
        _c("div", { staticClass: "page-help__bottom" }, [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("front.help.titles.need_more_help")))
              ]),
              _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      _vm.supportDialog = true
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("front.help.button.contact_us")))]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-support",
            "max-width": "900px",
            persistent: _vm.isDialogPersistent
          },
          model: {
            value: _vm.supportDialog,
            callback: function($$v) {
              _vm.supportDialog = $$v
            },
            expression: "supportDialog"
          }
        },
        [
          _vm.supportDialog
            ? _c("support-popup", {
                on: {
                  close: function($event) {
                    _vm.supportDialog = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }